// This file is generated by a script. Do not edit this file directly.
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
import React, { createContext, useContext } from 'react';
import { ChoiceGroupDirection, ChoiceGroupColumns, ChoiceGroupLayout } from "../../common/ChoiceGroupLayout/ChoiceGroupLayout";
var CheckboxGroupContext = /*#__PURE__*/createContext(null);
export var useCheckboxGroup = function useCheckboxGroup() {
  var context = useContext(CheckboxGroupContext);
  return context;
};
export var CheckboxGroup = function CheckboxGroup(_ref) {
  var label = _ref.label,
    description = _ref.description,
    error = _ref.error,
    helperText = _ref.helperText,
    _ref$direction = _ref.direction,
    direction = _ref$direction === void 0 ? ChoiceGroupDirection.VERTICAL : _ref$direction,
    _ref$layout = _ref.layout,
    layout = _ref$layout === void 0 ? ChoiceGroupColumns.SingleCol : _ref$layout,
    value = _ref.value,
    onChange = _ref.onChange,
    children = _ref.children,
    className = _ref.className,
    tooltipProps = _ref.tooltipProps;
  var handleCheckboxChange = function handleCheckboxChange(checkboxValue) {
    var newValue = value.includes(checkboxValue) ? value.filter(function (v) {
      return v !== checkboxValue;
    }) : [].concat(_toConsumableArray(value), [checkboxValue]);
    onChange(newValue);
  };
  return /*#__PURE__*/React.createElement(CheckboxGroupContext.Provider, {
    value: {
      value: value,
      onChange: handleCheckboxChange
    }
  }, /*#__PURE__*/React.createElement(ChoiceGroupLayout, {
    label: label,
    description: description,
    error: error,
    helperText: helperText,
    tooltipProps: tooltipProps,
    className: className,
    direction: direction,
    layout: layout
  }, children));
};
